import { render, staticRenderFns } from "./projectdetails.vue?vue&type=template&id=e87f9e5c&scoped=true&"
import script from "./projectdetails.vue?vue&type=script&lang=js&"
export * from "./projectdetails.vue?vue&type=script&lang=js&"
import style0 from "./projectdetails.vue?vue&type=style&index=0&id=e87f9e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87f9e5c",
  null
  
)

export default component.exports